import { Input } from './input.js';
import { Menu } from './menu.js';

const sizes = Object.entries({ ...Input.sizes }).reduce(
  (acc, [key, value]) => {
    acc[key] = { input: value.field };
    return acc;
  },
  {}
);
const Combobox = {
  parts: ["content", "label", "positioner", "trigger", "input", "control", "item", "itemIndicator"],
  baseStyle: {
    content: {
      ...Menu.baseStyle?.list
    },
    item: {
      ...Menu.baseStyle?.item
    },
    positioner: {},
    trigger: {
      color: "text-primary",
      position: "absolute",
      right: "12px",
      top: "50%",
      transform: "translateY(-50%)"
    },
    input: {
      ...Input.baseStyle?.field,
      width: "100%"
    },
    control: {
      position: "relative",
      width: "fit-content"
    },
    itemIndicator: {}
  },
  defaultProps: {
    size: "md"
  },
  sizes
};

export { Combobox };
